import moment from 'moment';
import { isEmpty } from 'lodash';

export const timestampTodate = (timestamp, language) => {
    if (timestamp === 0) return null;
    if (language === 'th') {
        moment.updateLocale('th', {
            meridiem: function (hour, minute, isLowercase) {
                if (hour >= 12)
                    return isLowercase ? 'pm' : 'PM';
                else
                    return isLowercase ? 'am' : 'AM';
            }
        });
        return moment(timestamp).add(543, 'year').format('Do MMM YYYY, hh:mm A')
    }
    if (language === 'cn') {
        moment.updateLocale('zh-cn', {
            meridiem: function (hour, minute, isLowercase) {
                if (hour >= 12)
                    return isLowercase ? 'pm' : 'PM';
                else
                    return isLowercase ? 'am' : 'AM';
            }
        });
        return moment(timestamp).format('LL, hh:mm A')
    }
    else
        return moment(timestamp).format('MMM Do YYYY,  hh:mm A')
}

export const durationToTime = (milliseconds) => {
    if (parseInt(milliseconds) >= 3600000) {
        return moment.utc(moment.duration(milliseconds).asMilliseconds()).format("HH:mm:ss");
    } else {
        return moment.utc(moment.duration(milliseconds).asMilliseconds()).format("mm:ss");
    }
}

export const dateToMillisecond = (date) => {
    if (moment(date, "MM/DD/YYYY HH:mm").format("MM/DD/YYYY HH:mm") === date) {
        return moment(date, "MM/DD/YYYY HH:mm").valueOf()
    }
    return null
}

export const convertWithDutationTime = (date, hours, minutes) => {
    return moment(date, "MM/DD/YYYY HH:mm")
        .add(hours, 'hours')
        .add(minutes, 'minutes')
        .valueOf()
}

export const disabledPastDay = (current) => {
    let customDate = moment().format('YYYY-MM-DD');
    return current && current < moment(customDate, "YYYY-MM-DD");
}

export const disabledPastHours = () => {
    var hours = [];
    for (let i = 0; i < moment().hour(); i++) {
        hours.push(i);
    }
    return hours;
}

export const disabledPastMinutes = (selectedHour) => {
    var minutes = [];
    if (selectedHour === moment().hour()) {
        for (var i = 0; i < moment().minute(); i++) {
            minutes.push(i);
        }
    }
    return minutes;
}


export const convertMillisecondToDate = (milliseconds) => {
    if (milliseconds) {
        return moment(milliseconds).format("YYYY-MM-DD HH:mm")
    }
    return null
}

export const dateDiffDuration = (startMillisecond, endMillisecond) => {
    if (startMillisecond && endMillisecond) {
        let start = moment(startMillisecond);
        let end = moment(endMillisecond);
        let duration = moment.duration(end.diff(start));
        let days = Math.floor(duration.asDays());
        let hours = Math.floor(duration.asHours());
        let minutes = Math.floor(duration.minutes())
        let seconds = Math.floor(duration.seconds())
        return {
            days, hours, minutes, seconds
        }
    }
    return {
        days: null,
        hours: null,
        minutes: null,
        seconds: null
    }
}

export const secondsContextToHms = (token) => {
    if (!isEmpty(token)) {
        let tokenString = new Buffer(token, 'base64').toString()
        let contextTime = JSON.parse(tokenString)
        let timeSecond = contextTime.r.d

        let second = Number(timeSecond);
        let hours = Math.floor(second / 3600);
        let minutes = Math.floor(second % 3600 / 60);

        return {
            hours,
            minutes
        }
    }
    return {
        hours: 0,
        minutes: 0
    }
}

export const getTimeRemaining = (startTime) => {
    const total = startTime - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
    const days = Math.floor(total / (1000 * 60 * 60 * 24));

    return {
        total,
        days,
        hours,
        minutes,
        seconds
    };
}

export const getLeftBarDate = () => {
    const leftBarLastDate = new Date()
    leftBarLastDate.setMonth(leftBarLastDate.getMonth() + 6)
    leftBarLastDate.setHours(23)
    leftBarLastDate.setMinutes(59)
    leftBarLastDate.setSeconds(59)
    const lastDate = Date.parse(leftBarLastDate)
    const dateNow = Date.parse(new Date())
    return {
        dateNow,
        lastDate
    }
}

export const getLandingUpcoming = () => {
    const leftBarLastDate = new Date()
    leftBarLastDate.setMonth(leftBarLastDate.getMonth() + 6)
    leftBarLastDate.setHours(23)
    leftBarLastDate.setMinutes(59)
    leftBarLastDate.setSeconds(59)
    const lastDate = Date.parse(leftBarLastDate)
    const currentDate = new Date()
    currentDate.setHours(0)
    currentDate.setMinutes(0)
    currentDate.setSeconds(0)
    const dateNow = Date.parse(currentDate)
    return {
        dateNow,
        lastDate
    }
}

export const getDaysCalendar = (initDate) => {
    //find firstDate on Calendar
    const previous = new Date(initDate)
    const firstDay = previous.setMonth(previous.getMonth() - 3);
    const lastDay = Date.parse(initDate)
    return {
        firstDay, lastDay
    }
}